import React from 'react'

import utils from './utils'
import TextArea from '../form/TextArea'

const PageTranslate = ({
    title, content, defaultLocale, targetLocale, allowEditing, id,
}) => (
    <tr>
        <td className="oid oid6" />
        <td style={{ padding: '4px 16px' }}>
            <b>{title}</b>
        </td>
        <td>{utils.getPageContent(content, defaultLocale)}</td>
        <td>
            {!allowEditing
                ? utils.getPageContent(content, targetLocale)
                : (
                    <TextArea
                        key={`${id}_${targetLocale}`}
                        defaultValue={utils.getPageContent(content, targetLocale)}
                        onBlur={({ value }) => utils.setPageContent(content, targetLocale, value)}
                    />
                )}
        </td>
    </tr>
)

export default PageTranslate
